import React from 'react';
import T from 'prop-types';

import AppInfo from '../../_shared/components/AppInfo';

const decorateApps = (apps) => apps.map((app) => ({ ...app, name: app.company_name }));

const TopApps = ({ data, isMobileView }) => (
  <div className="top-apps-wrapper">
    <h1 className="apps-title">{data.header}</h1>
    <div className="apps-list">
      {decorateApps(data.apps).map((app, index) => (
        <a key={index} className="app-item" href={app.app_link_url}>
          <AppInfo
            app={app}
            size={isMobileView ? 48 : 72}
            direction={isMobileView ? 'horizontal' : 'vertical'}
            enableTooltip={!isMobileView}
          />
          <div
            className="description"
            dangerouslySetInnerHTML={{
              __html: app.short_desc,
            }}
          />
        </a>
      ))}
    </div>
  </div>
);

TopApps.propTypes = {
  data: T.shape({
    header: T.string,
    apps: T.array,
  }).isRequired,
  isMobileView: T.bool.isRequired,
};

export default TopApps;
